import { Box } from "@mui/material";
import { Outlet, useOutletContext } from "react-router-dom";

const PatientVisitNoteLayout = () => {
  const patientData: any = useOutletContext();

  return (
    <Box height={"100%"} width={"100%"}>
      <Outlet context={patientData} />
    </Box>
  );
};
export default PatientVisitNoteLayout;
